module.exports = __webpack_public_path__ + "media/images/bg_company_mv-76a16977e6e700e00cfd39fa87771404.jpg";